/*
 * Сессийн cookie-ийн нэрс — proxy болон HTTP client ХОЁУЛАА эндээс уншина.
 *
 * Тус тусад нь бичсэнээс болж нэг нь "сесс байна", нөгөө нь "алга" гэж үзэн
 * redirect loop үүсэж байсан. Нэг эх сурвалжтай болгосноор дахин зөрөхгүй.
 */

/** Жинхэнэ refresh токен. httpOnly — зөвхөн сервер уншина. API-гийн REFRESH_COOKIE_NAME-тай таарна. */
export const REFRESH_COOKIE = 'coresoft_rt'

/**
 * Уншигдах дохио. Нууц агуулахгүй, юу ч нотлохгүй — панел "сэргээх оролдлого
 * хийх утгатай юу?" гэдгийг мэдэхэд л хэрэглэнэ.
 *
 * ! Энэ нь REFRESH_COOKIE-гийн ДАГАВАР бөгөөд түүнээс ХЭЗЭЭ Ч илүү эрх мэдэлтэй
 * ! байж болохгүй. Байхгүй байх нь "сесс алга" гэсэн үг БИШ — зөвхөн "мэдэхгүй".
 * ! Тиймээс proxy нь үндсэн cookie байгаад дохио нь алга бол өөрөө нөхөж тавина.
 */
export const REFRESH_COOKIE_HINT = `${REFRESH_COOKIE}_hint`
